export default "__VITE_ASSET__BuF8iNzE__"